export default "__VITE_ASSET__r5hghpJG__"